export const LOADING = 'deviceLoading';
export const ERROR = 'deviceError';
export const GETDEBUG = 'deviceGetDebug';
export const CLEARDEBUG = 'deviceClearDebug';
